import { motion } from "framer-motion";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";

import * as styles from "./styles.module.css";

const ImageReveal = ({ image, alt, color = "#b04027", caption }) => {
  return (
    <motion.div
      initial={{ boxShadow: `${color} 0 0 0` }}
      whileInView={{ boxShadow: `${color} 20px 20px 0` }}
      viewport={{ once: true }}
      transition={{ delay: 0.75 }}
      style={{
        border: `7px solid ${color}`,
        backgroundColor: color,
        position: "relative",
        marginBottom: "20px",
        overflow: "hidden",
      }}
    >
      <motion.div
        initial={{ x: "100%" }}
        whileInView={{ x: "0%" }}
        viewport={{ once: true }}
        transition={{
          delay: 0.2,
          duration: 0.4,
        }}
        style={{ position: "relative" }}
      >
        {caption && (
          <div className={styles.caption}>Photo credit: {caption}</div>
        )}
        <GatsbyImage image={image} alt={alt} />
      </motion.div>
    </motion.div>
  );
};

export default ImageReveal;
